import { render, staticRenderFns } from "./FieldList.vue?vue&type=template&id=2aa430e3&lang=pug&"
import script from "./FieldList.vue?vue&type=script&lang=ts&"
export * from "./FieldList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports